let GLOBAL = require('./globals');

const CategoryData = {
  async list() {
    const response = await fetch(`${GLOBAL.BASE_URL}api/categories-min/`);
    return await response.json();
  },
};

export default CategoryData;



// WEBPACK FOOTER //
// ./src/data/CategoryData.js